import { memo } from 'react';
import { Box, CssBaseline, useMediaQuery, useTheme } from '@mui/material';
import { IInspectionIpsativesProps } from 'interface/project/projectInfo';
import { Detail3PropsType, ICategoriesProps, ICmnInspectionProps } from 'interface/inspection/InspectionInfo';
import PlayerLeftCmn from './PlayerLeftCmn';
import PlayerRightCmn from './PlayerRightCmn';

interface DocumentViewerProps {
  info: IInspectionIpsativesProps[];
  result: ICmnInspectionProps[];
  categories: ICategoriesProps[];
  type?: 'NN' | 'N' | 'A' | 'AA' | Detail3PropsType;
  version: 'left1' | 'left2' | 'left3';
  total?: number;
}
function DocumentViewerCmn({ info, result, categories, type, version, total = 0 }: DocumentViewerProps): JSX.Element {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
      <CssBaseline />
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          gap: 2,
          height: isMobile ? 'auto' : 'calc(100vh)',
          maxHeight: isMobile ? 'none' : '864px',
          maxWidth: isMobile ? '100%' : '1536px',
          width: '100%',
          p: 3,
        }}
      >
        {/* playerLeft */}
        <PlayerLeftCmn
          isMobile={isMobile}
          inspectionData={info}
          result={result}
          type={type}
          version={version}
          total={total}
        />
        {/* playerRight */}
        <Box
          sx={{
            width: { xs: '100%', md: '540px' },
            bgcolor: 'background.paper',
            borderRadius: '12px',
            p: 0,
            height: { xs: 'auto', md: '100%' },
            overflowY: 'auto',
          }}
        >
          <PlayerRightCmn categories={categories} />
        </Box>
      </Box>
    </Box>
  );
}

export default memo(DocumentViewerCmn);
